import { userAtom } from "@/atoms/userAtom"
import { formatPhoneNumber } from "@/utils/FormatPhoneNumber"
import { IconProp } from "@fortawesome/fontawesome-svg-core"
import { faPen } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Tooltip, Typography } from "antd"
import { useTranslation } from "react-i18next"
import { useRecoilValue } from "recoil"
import SettingSection from "../../../shared/SettingSection"
import SettingContentWrapper from "../../../shared/SettingContentWrapper"
import LanguageSwitcher from "@/modules/shared/Localization/LanguageSwitcher"
import TimezoneSelect from "./TimezoneSelector"
import DateFormatSelect from "./DateFormatSelect"

const { Title } = Typography

interface UserDetailsProps {}

const UserDetails: React.FC<UserDetailsProps> = () => {
  const { t } = useTranslation()
  const user = useRecoilValue(userAtom)

  return (
    <SettingSection title={t("profile.GeneralSettings.generalSettings")}>
      <div className="flex flex-col gap-y-2 items-start">
        <LanguageSwitcher withLabel />
        <TimezoneSelect withLabel />
        <DateFormatSelect withLabel />
      </div>
      <SettingContentWrapper>
        {user && (
          <div className="flex flex-row border p-2 rounded-xl mb-2">
            <div className="flex flex-col px-3 py-1 w-full">
              <Title level={5}>{t("profile.TeamBusiness.userDetails")}</Title>
              {user?.firstName && (
                <p className="capitalize text-gray-500">
                  {user.firstName} {user.lastName}
                </p>
              )}
              {user?.role && <p className="capitalize text-gray-500">{user.role}</p>}
              {user?.email && <p className="text-gray-500">{user.email}</p>}
              {user?.phone && <p className="text-gray-500">{formatPhoneNumber(user.phone)}</p>}
            </div>
            <div className="flex items-center mr-4">
              <Tooltip placement="top" title={t("common.comingSoon")}>
                <span className="flex items-center rounded-full bg-gray-200 w-8 h-8 cursor-not-allowed">
                  <FontAwesomeIcon className="text-gray-400 mx-auto" icon={faPen as IconProp} />
                </span>
              </Tooltip>
            </div>
          </div>
        )}
      </SettingContentWrapper>
    </SettingSection>
  )
}

export default UserDetails
